/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../../../components/Form/Button";
import { PlusIcon } from "../../styles";
import { Wrapper, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-state-grid.svg");

type DespatchEmptySectionProps = {
  onAdd: () => void;
  buttonLabel: string;
  descriptionScreen: string;
  maintenanceScreen?: boolean;
  icon?: string;
};

export const DespatchEmptySection: React.FC<DespatchEmptySectionProps> = (props) => {
  const { buttonLabel, maintenanceScreen, descriptionScreen, onAdd, icon } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      data-cy="despatch-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={icon || defaultIcon} alt="empty state" />
      </Grid>
      <Grid item xs={4}>
        <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
      </Grid>
      <DescriptionContainer item xs={4}>
        <Description>
          {maintenanceScreen
            ? `${translate(
                "youWillBeAbleToSeeAllTheInformationAboutThe"
              )} ${descriptionScreen} ${translate("associatedWithTheDespatchWhenYouAddThem")}`
            : `${translate("youCanStartByCreatingANew")} ${descriptionScreen}`}
        </Description>
      </DescriptionContainer>
      <Grid item xs={3}>
        <Button onClick={onAdd} customColor={Color.SECONDARY}>
          <PlusIcon color="#ffffff" size={18} />
          {buttonLabel}
        </Button>
      </Grid>
    </Wrapper>
  );
};
